export default "__VITE_ASSET__B08ZG$as__"